import { useStockPrice } from "../../context/stockPrice/StockPriceContext";
import styles from "./MixAndMatchProductInfo.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import GreyBox from "../nonFunctionalComponents/greyBox/GreyBox";

export default function MixAndMatchProductInfo() {
  const { getTranslation } = useRuntimeConstants();
  const { shouldRetry } = useStockPrice();

  if (shouldRetry) {
    return null;
  }

  return (
    <GreyBox>
      <h2 className={styles.title}>
        {getTranslation("pdp_product_info_title")}
      </h2>
      <p className={styles.text}>{getTranslation("pdp_mixnmatch_message")}</p>
    </GreyBox>
  );
}
